import {
    Badge,
    Box,
    Button,
    Group,
    Modal,
    Paper,
    Select,
    SimpleGrid,
    Stack,
    Tabs,
    Text,
    TextInput,
    Textarea,
} from '@mantine/core';
import { useEffect, useState } from 'react';

import ConversationContainer from '../conversation/components/ConversationContainer';

const ConversationViewModal = ({ conversationId, opened, close }) => {
    return (
        <Modal.Root
            opened={opened}
            onClose={close}
            size='xl'>
            <Modal.Overlay />
            <Modal.Content>
                <Modal.Header>
                    <Modal.Title>Conversation {conversationId}</Modal.Title>
                    <Modal.CloseButton />
                </Modal.Header>
                <Modal.Body>
                    {conversationId ? (
                        <ConversationContainer
                            conversationId={conversationId}
                        />
                    ) : null}
                </Modal.Body>
            </Modal.Content>
        </Modal.Root>
    );
};
export default ConversationViewModal;
